module.exports = __webpack_public_path__ + "static/img/banner.f391b8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_5/banner.jpg
// module id = XEsp
// module chunks = 0